import React from "react";
import styled from "styled-components";
import Modal from "../common/Modal";
import DisableLogin from "./DisableLogin";
import withGetTopNine from "../../core/withGetTopNine";
import LoginFlow from "./LoginFlow";

const TopNineApp = ({
  setDisableLoginState,
  disableLoginState,
  loading,
  disableAnonymousLogin,
  email,
  ...props
}) => (
  <Container>
    {!loading && (
      <LoginFlow
        disableAnonymousLogin={disableAnonymousLogin}
        setDisableLoginState={props.setDisableLoginState}
        email={email}
        {...props}
      />
    )}
    <DisableLoginModal
      open={disableLoginState.open}
      onRequestClose={() => setDisableLoginState({ open: false })}
      error={disableLoginState.error}
      email={email}
      {...props}
    />
  </Container>
);

const DisableLoginModal = props => (
  <Modal {...props} showCloseButton={false}>
    <DisableLogin {...props} />
  </Modal>
);

const Loading = styled.span`
  font-family: Montserrat;
  font-weight: 700;
  color: white;
  font-size: 24px;
`;

const Container = styled.div`
  width: 90%;
  max-width: 500px;
  margin: 16px 0;
  @media screen and (max-width: 500px) {
    max-width: none;
    width: 100%;
  }
`;

export default withGetTopNine(TopNineApp);
